import { useTranslation } from 'react-i18next';

import { Numeric } from '../../../../../types/general';

type Props = {
  title?: string;
  serialNumber?: Numeric | null;
  isGroupDialog: boolean;
  isEditDialog: boolean;
  orderIndex?: number;
  ordersCount: number;
};

export function DialogHeader({
  title,
  isEditDialog,
  serialNumber,
  isGroupDialog,
  orderIndex,
  ordersCount,
}: Props) {
  const { t } = useTranslation();

  return (
    <>
      {title ? (
        title
      ) : isGroupDialog ? (
        <>
          <div>
            {t('Group Order {{serialNumber}}', {
              serialNumber,
            })}{' '}
          </div>

          {isGroupDialog && (
            <div className="group-buttons">
              {(orderIndex ?? 0) + 1} {t('of')} {ordersCount}
            </div>
          )}
        </>
      ) : isEditDialog ? (
        t('Edit Order {{serialNumber}}', { serialNumber: serialNumber })
      ) : (
        t('Create Order')
      )}
    </>
  );
}
